import localStorage from 'localstorage-ttl';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';

import { useStores } from '../hooks/useStores';
import { AuthProviders } from '../types/shared';
import config from '../utils/config';
import gup from '../utils/getUrlQueryParam';

const useDataStore = () => {
    const { store } = useStores();
    return {
        getAccessToken: store.auth.getAccessToken,
        signInGuest: store.auth.signInGuest,
    };
};

const AuthCallback: React.FC = () => {
    const { getAccessToken, signInGuest } = useDataStore();
    const history = useHistory();
    useEffect(() => {
        const code = gup('code');
        const state = gup('state');
        // eslint-disable-next-line no-debugger
        if (history.location.pathname === '/auth/callback-spotify-guest') {
            signInGuest(AuthProviders.SPOTIFY, code, state)
                .then(() => {
                    history.push(localStorage.get(config.LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT));
                })
                .catch(error => {
                    console.log(error);
                });
            return;
        }
        getAccessToken(code, state)
            .then(() => {
                history.push('/');
            })
            .catch(error => {
                console.log(error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div className="AuthCallback">...Loading</div>;
};

export default AuthCallback;
